<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevoRegistro()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i> NUEVO           
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>

    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [id]="DAT_AG_GRID.id" 
                    [columnDefs]="columnDefs" 
                    [frameworkComponents]="frameworkComponents"
                    [ngStyle]="DAT_AG_GRID.style" 
                    [paginationPageSize]="DAT_AG_GRID.paginacion"
                    [pagination]="true"                     
                    [rowData]="rowData">
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'"
                [innTemplate]="abrirModal" [titulo]="titleModal"></app-lfsa-modal>

<ng-template #abrirModal>  
  <div class="container-fluid">
    <form [formGroup]="mantenerRegistroForm" mat-dialog-content>
      <div class="row">        
        <div class="col-12 col-md-6">
          <div class="mb-2">
            <label for="">Ingrese Material</label>
            <!-- (keydown)="noWhitespace($event)" en el input-->
            <input (change)="onChangeMaterial($event)"
                   (keyup)="onChangeMaterial($event); this.mantenerRegistroForm.controls['material'].value.length > 0 ? onChangeMaterial($event): ''"
                   autocomplete="off" class="form-control is-invalid"
                   formControlName="material"
                   id="material" name="material"
                   type="text">

            <div *ngIf="this.mantenerRegistroForm.get('material')?.hasError('required') && this.mantenerRegistroForm.get('material').touched" class="text-danger"><small>*Este campo es requerido</small></div>
            <div *ngIf="this.mantenerRegistroForm.get('material')?.hasError('maxLength') && this.mantenerRegistroForm.get('material').touched" class="text-danger"><small>*Máximo 10 caracteres</small></div>
            <div *ngIf="materialInvalido" class="text-danger mt-3"><small>*Este material es inválido</small></div>
          </div>
        </div>

        <div class="form-group col-12 col-md-6">
          <app-lfsa-input [control]="this.mantenerRegistroForm.get('desMaterial')" [id]="'desMaterial'" [isReadOnly]="true"
                          [label]="'Descripción del Material'" formControlName="desMaterial" type="text">
          </app-lfsa-input>
        </div>

        <div class="form-group col-12 col-md-4">
          <app-lfsa-input (keypress)="keyDecimals($event)" [control]="this.mantenerRegistroForm.get('dobiInicio')" [id]="'dobiInicio'"
                          [label]="'Valor DOBI Inicial'"
                          formControlName="dobiInicio" placeholder="Ej: 1.2345"
                          type="number"></app-lfsa-input>
          <small *ngIf="this.mantenerRegistroForm.get('dobiInicio')?.hasError('pattern')" class="letrasDanger">*Solo números y punto. Ej: 12.3456</small>
        </div>

        <div class="form-group col-12 col-md-4">
          <app-lfsa-input (keypress)="keyDecimals($event)" [control]="this.mantenerRegistroForm.get('dobiFinal')" [id]="'dobiFinal'"
                          [label]="'Valor DOBI Final'"
                          formControlName="dobiFinal" placeholder="Ej: 1.2345"
                          type="number"></app-lfsa-input>
          <small *ngIf="mantenerRegistroForm.get('dobiFinal')?.hasError('pattern')" class="letrasDanger">*Solo números y punto. Ej: 12.3456</small>
        </div>

        <div class="form-group col-12 col-md-4">
          <label for="tpCalidad">Tipo de Calidad</label>
          <select class="form-control" formControlName="tpCalidad" id="tpCalidad">
            <option value="">-- Seleccione --</option>
            <option value="A">A</option>
            <option value="B">B</option>
            <option value="C">C</option>
          </select>
          <small *ngIf="mantenerRegistroForm.get('tpCalidad')?.hasError('required') && mantenerRegistroForm.get('tpCalidad').touched" class="text-danger">*Este campo es requerido</small>
        </div>

      </div>

      <app-lfsa-botones-formulario (devolverAccion)="acciones($event)" 
        [formularioValido]="mantenerRegistroForm.invalid"
        [loading]="loading" [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>

    </form>
  </div>
</ng-template>
<!-- END MODAL -->
